// extracted by mini-css-extract-plugin
export default {"root":"Adverts_root__DxGuO"};